
import React, { useState } from 'react';
import { Form, Input, Button, Card, App, Typography } from 'antd';
import { UserOutlined, LockOutlined, RocketOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import analysisApi from '../../services/api';
import './index.css';

const { Title, Text } = Typography;

const LoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { message } = App.useApp();

  React.useEffect(() => {
    // 如果已登录，自动跳转到门户页
    const token = localStorage.getItem('auth_token');
    if (token) {
      navigate('/portal');
    }
  }, [navigate]);

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      const { username, password } = values;
      const data = await analysisApi.login(username, password);
      
      // 保存 token
      localStorage.setItem('auth_token', data.access_token);
      message.success('登录成功');
      
      // 登录成功后跳转到门户页
      navigate('/portal');
    } catch (error) {
      console.error('Login error:', error);
      message.error('登录失败，请检查用户名或密码');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card" variant="borderless">
        <div className="login-header">
          <div className="logo-wrapper">
            <RocketOutlined className="logo-icon" />
          </div>
          <Title level={3} className="login-title">CheeseSmart Admin</Title>
          <Text className="login-subtitle">量化策略系统 · 内部维护端</Text>
        </div>
        
        <Form
          name="login_form"
          className="login-form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          size="large"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input 
              prefix={<UserOutlined className="site-form-item-icon" />} 
              placeholder="admin" 
            />
          </Form.Item>
          
          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              placeholder="••••••••"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-form-button" loading={loading} block>
              登 录
            </Button>
          </Form.Item>
          
          <div className="login-footer">
            <Text type="secondary" style={{ fontSize: '12px' }}>
              © 2025 CheeseSmart Quant Team
            </Text>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default LoginPage;
